export default "/images/warning-icon-red-small.svg";